import React from 'react';

const flagUrls = import.meta.glob('../../../icons/flags/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

const flagByAlpha3: Record<string, string> = Object.fromEntries(
  Object.entries(flagUrls).map(([path, url]) => {
    const alpha3 = path.split('/').pop()!.replace(/\.svg$/i, '').toUpperCase();
    return [alpha3, url];
  }),
);

interface CountryFlagProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  code?: string | null;
}

const CountryFlag: React.FC<CountryFlagProps> = ({ code, className, alt, ...rest }) => {
  if (!code) return null;
  const upper = code.toUpperCase();
  const url = flagByAlpha3[upper];
  if (!url) return null;
  return (
    <img
      src={url}
      alt={alt ?? upper}
      className={className ?? 'inline-block h-3 w-auto align-middle'}
      {...rest}
    />
  );
};

export default CountryFlag;
